const MASONRY_LOG_PREFIX = '[Masonry]:';

/**
 * Dev-mode-only warning when required analytics fields (product_area,
 * sub_product_area, screen_name) are missing from analytics data
 * (for example, a masonry widget's analytics config or a backend-driven
 * analytics payload). Does nothing in production builds.
 */
export const warnMissingAnalyticsFields = (
  context: string,
  fields: Record<string, string | undefined | null>,
) => {
  if (process.env.NODE_ENV !== 'development') return;

  const missing = Object.entries(fields)
    .filter(([, value]) => value == null || value === '')
    .map(([name]) => name);

  if (missing.length > 0) {
    console.warn(
      `${MASONRY_LOG_PREFIX} ${context} is missing required analytics fields: ${missing.join(
        ', ',
      )}.`,
    );
  }
};
